export const SPOTIFY_CLIENT_ID = 'bd118ce67c72490e9fda1d4eef58a173';
export const SPOTIFY_CLIENT_SECRET = 'e3a48c2f013c40fb821f2b1cdb745658';
